export function round(num) { return parseFloat(Math.round(num * 100) / 100).toFixed(2); }


// WEBPACK FOOTER //
// ./src/utils/math.js